import React, { useContext, useState, useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import { _t, getSystemSettings, deleteCookie, } from "../../functions/Functions";
import { useCustomHooks } from "../../functions/Hooks";
//context consumer
import { SettingsContext } from "../../contexts/Settings";
import { UserContext } from "../../contexts/User";
import { BASE_URL } from "../../BaseUrl";

const Footer = () => {
  const { firebaseAuth } = useCustomHooks();
  //getting context values here
  let { generalSettings } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);

  let weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // console.log("Footer : ", generalSettings);

  const style = {
    logo: {
      backgroundColor:
        generalSettings &&
        getSystemSettings(generalSettings, "type_background"),
      backgroundImage:
        // generalSettings &&
        //`url(${getSystemSettings(generalSettings, "type_logo_footer")})`,
        // `url("https://sync.indoljpos.com/public/images/logo/1618997935-logo2png.png")`,
        `url(${BASE_URL + "/images/logo/1618997935-logo2png.png"})`,
    },
    clock: {
       color: "#fff",
        // generalSettings && getSystemSettings(generalSettings, "type_clock"),
    },
    clockText: {
      color: "#414141",
      clockText: "bold"
      
      //generalSettings && getSystemSettings(generalSettings, "type_color"),
    },
    clockIcon: {
      color: "#414141",
      //generalSettings && getSystemSettings(generalSettings, "type_clock"),
        // generalSettings && getSystemSettings(generalSettings, "type_color"),
    },
  };

  const [invoiceMessage, setInvoiceMessage] = useState("")

  const needsFirebaseRevalidation = useMemo(() => {
    return (
      Boolean(
      getSystemSettings(generalSettings, "firebase_collection") &&
      !(window.location.pathname === "/dashboard/pos/online-orders" ||
        window.location.pathname === "/dashboard/pos/foodpanda" ||
        window.location.pathname === "/dashboard/pos" ||
        window.location.pathname === "/dashboard/pos/submitted" ||
        window.location.pathname === "/dashboard/pos/settled"))
    );
  }, [generalSettings]); 

  //notify firebase for invoice 
  const fetchInvoiceStatus = () => {
    const url = "pos/" + (getSystemSettings(generalSettings, "firebase_collection")) + '/invoiceNotify/merchant';
    
    return firebaseAuth(url, (error, data) => {
      if (error) {
        console.error("Firebase Error:", error);
        return;
      }
      if(data){
        if(data && data.status?.toLowerCase() === "default"){
          setInvoiceMessage("")
        }else if(data && data.status?.toLowerCase() === "block"){
          setTimeout(() => {
            deleteCookie()            
          }, 5000);
        }else{
          setInvoiceMessage(data)
        }
      }
    })
  }
  
  useEffect(()=>{
    if(!authUserInfo?.details || !generalSettings) return;
    let unsubPromise;
    unsubPromise = fetchInvoiceStatus()

    return () => {
      if (unsubPromise) {
        unsubPromise.then(unsub => {
          if (typeof unsub === "function") unsub();
        }).catch(err => console.error("Error unsubscribing:", err));
      }
    };
  },[authUserInfo?.details])

  return (
    <>
      {window.location.pathname !== "/" &&
      window.location.pathname !== "/profile" &&
      window.location.pathname !== "/profile/" &&
      window.location.pathname !== "/my-orders" &&
      !window.location.pathname.startsWith("/digital-menu") &&
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/login/" &&
      window.location.pathname !== "/sign-up" &&
      window.location.pathname !== "/sign-up/" &&
      window.location.pathname !== "/delivery-man-registration" &&
      window.location.pathname !== "/delivery-man-registration" &&
      window.location.pathname !== "/installation" &&
      window.location.pathname !== "/installation/" &&
      window.location.pathname !== "/installation/permission-chcek" &&
      window.location.pathname !== "/installation/permission-chcek/" &&
      window.location.pathname !== "/installation/database-setup" &&
      window.location.pathname !== "/installation/database-setup/" &&
      window.location.pathname !== "/installation/import-database" &&
      window.location.pathname !== "/installation/import-database/" &&
      window.location.pathname !== "/installation/add-admin-user" &&
      window.location.pathname !== "/installation/add-admin-user/" &&
      window.location.pathname !== "/installation/congratulation" &&
      window.location.pathname !== "/installation/congratulation/" &&
      window.location.pathname !== "/dashboard/pos" &&
      window.location.pathname !== "/dashboard/pos/" &&
      window.location.pathname !== "/reset-password" &&
      window.location.pathname !== "/reset-password/" &&
      window.location.pathname !== "/sales-listing" &&
      !window.location.pathname.includes("/feedback/") &&
      !window.location.pathname.includes("/order-details/") &&
      !window.location.pathname.includes("/set-new-password") &&
      !window.location.pathname.includes("order-screen") &&
      !window.location.pathname.includes("orderscreen") ? (
        <footer key={1} id="footer" className="sicky-bottom pos-footer pos-footer--new-design">
          <div
            className={`${
              window.location.pathname.includes("/dashboard/kitchen") ||
              window.location.pathname.includes("/dashboard/orders") ||
              window.location.pathname.includes("/dashboard/online-orders")
                ? "container-fluid"
                : "container-fluid"
            }`}
          >
            <div className="row align-items-center">
              <div className="col-4 mb-lg-0">
                {/* <div className="fk-brand--footer fk-brand--footer-sqr mx-auto mr-lg-auto ml-lg-0">
                  {getCookie() !== undefined
                    ? [
                        window.location.pathname === "/dashboard" ? (
                          <NavLink
                            to={{ pathname: "/refresh", state: "/dashboard" }}
                            exact
                            className="t-link w-100 t-h-50"
                            key="footerlogo"
                          >
                            <span
                              className="fk-brand--footer-img fk-brand__img--fk"
                              style={style.logo}
                            ></span>
                          </NavLink>
                        ) : (
                          <NavLink
                            to="/dashboard"
                            className="t-link w-100 t-h-50"
                            key="footerlogo"
                          >
                            <span
                              className="fk-brand--footer-img fk-brand__img--fk"
                              style={style.logo}
                            ></span>
                          </NavLink>
                        ),
                      ]
                    : [
                        window.location.pathname === "/" ? (
                          <NavLink
                            to={{ pathname: "/refresh", state: "/" }}
                            exact
                            className="t-link w-100 t-h-50"
                          >
                            <span
                              className="fk-brand--footer-img fk-brand__img--fk"
                              style={style.logo}
                            ></span>
                          </NavLink>
                        ) : (
                          <NavLink to="/" className="t-link w-100 t-h-50">
                            <span
                              className="fk-brand--footer-img fk-brand__img--fk"
                              style={style.logo}
                            ></span>
                          </NavLink>
                        ),
                      ]}
                </div> */}
                  {
                    invoiceMessage && invoiceMessage?.message && (
                      <div data-status={invoiceMessage.status} className="invoice-indicator">
                        {invoiceMessage.message}
                      </div>
                    )
                  }
              </div>
              <div className="col-4 mb-lg-0">
                <p className="mb-0 text-center sm-text-newclass powered-by ">
                  &copy;{" "} 
                  {generalSettings &&
                    getSystemSettings(generalSettings, "type_footer")}
                </p>
              </div>
              <div className="col-4 ">
                <div className="clock" style={style.clock}>
                  <div className="clock__icon " style={style.clockIcon}>
                      <img src={"/assets/img/time.svg"} alt="time" className="img-fluid" style={{width:"35px", height:"30px"}} />
                  </div>
                  <div className="clock__content d-flex flex-column align-items-center">
                    <div
                      id="MyClockDisplay"
                      className="clockDisply"
                      style={style.clockText}
                      onLoad={() => {
                        "showTime()";
                      }}
                    ></div>
                    <p
                      className="mb-0 font-10px font-weight-normal mx-2"
                      style={style.clockText}
                    >
                      {weekday[new Date().getDay()]}, {new Date().getDate()}{" "}
                      {month[new Date().getMonth()]}, {new Date().getFullYear()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      ) : (
        [
          (window.location.pathname.includes("/dashboard/pos") &&
            window.location.pathname !== "/" &&
            window.location.pathname !== "/profile" &&
            window.location.pathname !== "/my-orders" &&
            !window.location.pathname.startsWith("/digital-menu") &&
            window.location.pathname !== "/delivery-man-registration") ? (
              <footer key={2} id="footer" className="sticky-bottom  mb-md-0 pos-footer pos-footer--new-design">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-4 mb-lg-0">
                      <div className="mx-auto mr-lg-auto ml-lg-0">
                        {/* {getCookie() !== undefined
                          ? [
                              window.location.pathname === "/dashboard" ? (
                                <NavLink
                                  to={{
                                    pathname: "/refresh",
                                    state: "/dashboard",
                                  }}
                                  exact
                                  className="t-link w-100 t-h-50"
                                  key="footerlogo"
                                >
                                  <span
                                    className="fk-brand--footer-img fk-brand__img--fk"
                                    style={style.logo}
                                  ></span>
                                </NavLink>
                              ) : (
                                <NavLink
                                  to="/dashboard"
                                  className="t-link w-100 t-h-50"
                                  key="footerlogo"
                                >
                                  
                                </NavLink>
                              ),
                            ]
                          : [
                              window.location.pathname === "/" ? (
                                <NavLink
                                  to={{ pathname: "/refresh", state: "/" }}
                                  exact
                                  className="t-link w-100 t-h-50"
                                >
                                  <span
                                    className="fk-brand--footer-img fk-brand__img--fk"
                                    style={style.logo}
                                  ></span>
                                </NavLink>
                              ) : (
                                <NavLink to="/" className="t-link w-100 t-h-50">
                                  <span
                                    className="fk-brand--footer-img fk-brand__img--fk"
                                    style={style.logo}
                                  ></span>
                                </NavLink>
                              ),
                            ]} */}
                          {
                            invoiceMessage && invoiceMessage?.message && (
                              <div data-status={invoiceMessage.status} className="invoice-indicator">
                                {invoiceMessage.message}
                              </div>
                            )
                          }
                      </div>
                    </div>
                    <div className="col-4 mb-lg-0">
                      <p className="mb-0 text-center sm-text-newclass powered-by">
                        &copy;{" "}
                       {/* Mystic Grill*/ }
                        {generalSettings &&
                          getSystemSettings(generalSettings, "type_footer")}
                      </p>
                    </div>
                    <div className="col-4">
                      <div className="clock" style={style.clock}>
                        <div
                          className="clock__icon "
                          style={style.clockIcon}
                        >
                          {/* <span
                            className="fa fa-clock-o"
                            style={style.clockIcon}
                          ></span> */}
                          <img src={"/assets/img/time.svg"} alt="time" className="img-fluid" style={{width:"35px", height:"30px"}} />
                        </div>
                        <div className="clock__content  d-flex flex-column align-items-center">
                          <div
                            id="MyClockDisplay"
                            className="clockDisply"
                            style={style.clockText}
                            onLoad={() => {
                              "showTime()";
                            }}
                          ></div>
                          <p
                            className="mb-0 font-10px font-weight-normal mx-2"
                            style={style.clockText}
                          >
                            {weekday[new Date().getDay()]},{" "}
                            {new Date().getDate()}{" "}
                            {month[new Date().getMonth()]},{" "}
                            {new Date().getFullYear()}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            ) : "",
        ]
      )}
    </>
  );
};

export default withRouter(React.memo(Footer));
